import { useCallback } from 'react';
import { Selection } from '@leverege/ui-redux';
export default function useListSelection({
  dispatch,
  selected,
  selectionKey,
  options = {}
}) {
  const {
    idKey,
    idFunc
  } = options;
  const getKey = useCallback(item => {
    if (idFunc && typeof idFunc === 'function') {
      return idFunc(item);
    }
    return idKey ? item[idKey] : item;
  }, [idKey, idFunc]);
  const isSelected = useCallback(item => {
    const key = getKey(item);
    return Selection.isSelected(selected, key);
  }, [selected]);
  const onSelect = useCallback(event => {
    const {
      value
    } = event;
    const key = getKey(value);
    if (Selection.isSelected(selected, key)) {
      dispatch(Selection.clear(selectionKey));
    } else {
      dispatch(Selection.set(selectionKey, [value]));
    }
  });
  return {
    isSelected,
    onSelect
  };
}